/* tslint:disable */
 
import { LocalizedValue } from './localized-value';
import { NullableActionTargetStep } from './nullable-action-target-step';
import { NullableLocalizedValue } from './nullable-localized-value';
import { WorkflowAction } from './workflow-action';
import { WorkflowStepOwner } from './workflow-step-owner';
import { WorkflowStepTimeMonitoring } from './workflow-step-time-monitoring';
export class WorkflowStep {
  actions?: Array<WorkflowAction>;
  allowAddAdHoc?: boolean;
  description?: null | NullableLocalizedValue;
  fallbackOwner?: Array<WorkflowStepOwner>;
  id?: string;
  inMainFlow?: boolean;
  mainFlowIndex?: number;
  mergeStep?: null | NullableActionTargetStep;
  name: LocalizedValue;
  owner?: WorkflowStepOwner;

  /**
   * ID of the sub-workflow to execute
   */
  subWorkflowId?: null | string;
  timeMonitoring?: null | WorkflowStepTimeMonitoring;
  type: 0 | 1 | 2 | 3 | 4;
}
